import React from 'react';
import { Menu, X } from 'lucide-react';
import { cn } from '@/utils/cn';

export interface MenuToggleProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

export const MenuToggle: React.FC<MenuToggleProps> = ({ isOpen, onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100',
        'transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500',
        className
      )}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
    >
      {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
    </button>
  );
};

export default MenuToggle;